import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  sendFeedbackV1: {
    method: 'POST',
    url: `${configs.baseUrl}/api/question/private`,
  },
  sendFeedbackV2: {
    method: 'POST',
    url: `${configs.baseUrl}/api/private-feedbacks`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const sendFeedbackV1 = async (payload) => {
  const res = await resource.sendFeedbackV1(payload)
  return res.body
}

const sendFeedbackV2 = async (payload) => {
  const res = await resource.sendFeedbackV2(payload)
  return res.body
}

export default {
  initResource,
  sendFeedbackV1,
  sendFeedbackV2,
}
